module.exports = __webpack_public_path__ + "img/circle__button.36086aae.svg";